import React, {useEffect, useState} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import {DoctorAllocatedDeviceModel} from '../../../../entities/device.entity'
import PrimaryButton from '../common/buttons/PrimaryButton'
import SearchBot from '../common/bots/SearchBot'

interface AssignDevicePatientModalProps {
  isOpen: boolean
  onClose: () => void
  devicesList: DoctorAllocatedDeviceModel[]
  handleAssign: (device: DoctorAllocatedDeviceModel, resetForm: () => void) => void
}

const AssignDevicePatientModal: React.FC<AssignDevicePatientModalProps> = ({
  isOpen,
  onClose,
  devicesList,
  handleAssign,
}) => {
  const [selectedDevice, setSelectedDevice] = useState<DoctorAllocatedDeviceModel | null>(null)
  const [isAssigning, setIsAssigning] = useState(false)

  const handleClose = () => {
    setSelectedDevice(null) // Reset form
    setIsAssigning(false) // Reset loading state
    onClose()
  }

  const handleAssignDevice = async () => {
    if (!selectedDevice) return
    
    setIsAssigning(true)
    
    // Add a small delay to ensure loading state is visible
    setTimeout(async () => {
      try {
        handleAssign(selectedDevice, () => setSelectedDevice(null))
        // Keep loading state for at least 500ms to show feedback
        setTimeout(() => {
          setIsAssigning(false)
        }, 500)
      } catch (error) {
        console.error('Assignment failed:', error)
        setIsAssigning(false)
      }
    }, 100)
  }
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setFilteredData] = useState<DoctorAllocatedDeviceModel[]>(devicesList)

  useEffect(() => {
    if (devicesList && devicesList.length > 0) {
      setFilteredData(devicesList)
    }
  }, [devicesList])

  useEffect(() => {
    if (!searchTerm) {
      setFilteredData(devicesList)
      return
    }
    const filtered = devicesList.filter(
      (device) =>
        device?.Device?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        device?.Device?.imei?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    setFilteredData(filtered)
  }, [searchTerm, devicesList])

  return (
    <>
      {isOpen && (
        <div
          onClick={handleClose}
          className='modal-backdrop show'
          style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
        />
      )}
      <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Assign Device</h5>
              <button type='button' className='btn-close' onClick={handleClose}></button>
            </div>
            <div className='modal-body'>
              <h5>Available Devices</h5>

              {/* search bot */}
              <SearchBot
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder='Search by name'
                className='mb-3'
              />

              {filteredData?.length > 0 ? (
                <>
                  <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                    {filteredData.map((device) => (
                      <div
                        key={device.id}
                        className={`d-flex justify-content-between align-items-center p-2 border ${
                          selectedDevice?.id === device.id ? 'bg-primary text-white' : ''
                        }`}
                      >
                        <div>
                          <strong>{device.Device?.name}</strong>
                          <br />
                          <small>IMEI: {device.Device?.imei}</small>
                        </div>
                        <PrimaryButton
                          color={selectedDevice?.id === device.id ? 'success' : 'primary'}
                          onClick={() => setSelectedDevice(device)}
                        >
                          {selectedDevice?.id === device.id ? 'Selected' : 'Select'}
                        </PrimaryButton>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <h5 className='text-center'>No Devices are available!</h5>
              )}
            </div>
            <div className='modal-footer'>
              <PrimaryButton
                onClick={handleAssignDevice}
                disabled={!selectedDevice || isAssigning}
              >
                {isAssigning ? (
                  <span className='d-flex align-items-center'>
                    <span className='spinner-border spinner-border-sm me-2' aria-hidden='true'></span>
                    Assigning...
                  </span>
                ) : (
                  'Assign Device'
                )}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignDevicePatientModal
